import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_translatable_input = _resolveComponent("translatable-input")!
  const _component_commissions_selector = _resolveComponent("commissions-selector")!
  const _component_date_selector = _resolveComponent("date-selector")!
  const _component_file_selector = _resolveComponent("file-selector")!
  const _component_crud_dialog = _resolveComponent("crud-dialog")!

  return (_openBlock(), _createBlock(_component_crud_dialog, {
    language: _ctx.language,
    "onUpdate:language": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.language) = $event)),
    visible: _ctx.visible,
    title: _ctx.t('Create new document archive'),
    errors: _ctx.errors,
    "is-processing": _ctx.isProcessing,
    medium: "",
    languageSelect: "",
    "with-save": "",
    onClose: _cache[8] || (_cache[8] = ($event: any) => (_ctx.visible = !_ctx.visible)),
    onSave: _ctx.saveDocumentArchive
  }, {
    default: _withCtx(() => [
      _createVNode(_component_translatable_input, {
        modelValue: _ctx.newDocumentArchive.title,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.newDocumentArchive.title) = $event)),
        "is-valid": _ctx.isValidTitle,
        "onUpdate:is-valid": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.isValidTitle) = $event)),
        language: _ctx.language,
        title: _ctx.t('Title'),
        type: "text"
      }, null, 8, ["modelValue", "is-valid", "language", "title"]),
      _createVNode(_component_commissions_selector, {
        modelValue: _ctx.newDocumentArchive.commission,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.newDocumentArchive.commission) = $event)),
        "is-valid": _ctx.isValidCommissionSelector,
        "onUpdate:is-valid": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.isValidCommissionSelector) = $event)),
        required: "",
        "single-select": "",
        "user-commissions": !_ctx.user?.is_admin
      }, null, 8, ["modelValue", "is-valid", "user-commissions"]),
      _createVNode(_component_date_selector, {
        label: _ctx.t('Meeting date'),
        modelValue: _ctx.newDocumentArchive.meeting_date,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.newDocumentArchive.meeting_date) = $event))
      }, null, 8, ["label", "modelValue"]),
      _createVNode(_component_file_selector, {
        modelValue: _ctx.documents,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.documents) = $event)),
        "is-valid": _ctx.isValidDocumentsSelector,
        "onUpdate:is-valid": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.isValidDocumentsSelector) = $event)),
        label: _ctx.t('Documents'),
        required: "",
        class: "q-mt-md"
      }, null, 8, ["modelValue", "is-valid", "label"])
    ]),
    _: 1
  }, 8, ["language", "visible", "title", "errors", "is-processing", "onSave"]))
}